import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: 'root' })
export class TranslateHelper {
    private translateService = inject(TranslateService)

    public common(key: string): string {
        return this.getValue("common", key);
    }

    public shopping(key: string): string {
        return this.getValue("shopping", key);
    }

    public errors(key: string): string {
        return this.getValue("errors", key);
    }

    public steps(key: string): string {
        return this.getValue("steps", key);
    }

    public paymentForm(key: string): string {
        return this.getValue("paymentForm", key);
    }

    public summaryForm(key: string): string {
        return this.getValue("summaryForm", key);
    }

    public refund(key: string): string {
        return this.getValue("refund", key);
    }

    private getValue(group: string, key: string): string {
        return this.translateService.instant(group + "." + key);
    }
};